module.exports = __webpack_public_path__ + "media/application/images/2018/2018-dir-lock-c158e4f3585fa0d508374fe3561807f2.svg";